var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('toolbar',{staticClass:"z-50"}),_vm._v(" "),_c('main',{staticClass:"flex-grow overflow-x-hidden z-40"},[_c('nuxt')],1),_vm._v(" "),_c('app-footer',{staticClass:"mt-40"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }